import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {},
  productNameChip: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  chipWrapper: {
    marginBottom: theme.spacing(2.5),
  },
  productImageName: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2.5),
  },
  productImageContainer: {
    width: '50px',
    maxHeight: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  productImage: {
    maxWidth: '100%',
    maxHeight: '100%',
  },
  companyName: {
    fontSize: '0.875rem',
    marginLeft: '0.75rem',
    textAlign: 'left',
    fontWeight: 600,
  },
  chipContainer: {
    padding: '0.375rem 0.75rem',
  },
  agreementBetweenContainer: {
    backgroundColor: theme.palette.secondary.main,
    padding: theme.spacing(2, 2, 2, 2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    ['@media (max-width: 600px)']: {
      padding: theme.spacing(2, 2, 2, 2),
    },
  },
  agreementBetween: {
    fontWeight: 600,
    fontSize: '0.875rem',
    marginBottom: theme.spacing(2),
    ['@media (max-width: 600px)']: {
      fontSize: '0.75rem',
    },
  },
  isvResellerContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  isvReseller: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    maxWidth: '550px',
  },
  agreementCompany: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  companyLogoTitle: {
    display: 'flex',
    textAlign: 'left',
    ['&:first-of-type']: {
      marginRight: theme.spacing(2.5),
    },
  },
  sellerImageContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '46px',
    height: '46px',
    flexShrink: 0,
    marginRight: theme.spacing(2.5),
  },
  sellerImage: {
    maxWidth: '100%',
    maxHeight: '100%',
  },
  agreementCompanyTitle: {
    fontWeight: 600,
    color: theme.palette.primary.light,
    marginBottom: theme.spacing(1),
    ['@media (max-width: 600px)']: {
      fontSize: '0.75rem',
    },
  },
  agreementName: {
    fontSize: '0.875rem',
    ['@media (max-width: 600px)']: {
      fontSize: '0.75rem',
    },
  },
}))
